export default __webpack_public_path__ + "static/media/withdrawal.f68698c5.svg";